import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography
} from "@mui/material";

const HomeMadeDialog = ({
                            isOpen,
                            fnConfirmAction,
                            fnClose,
                            title,
                            text,
                            labelClose,
                            labelConfirm,
                            hideDefaultButtons = false,
                            customActions = null
                        }) => {
    return (
        <Dialog
            open={isOpen}
            onClose={fnClose}
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    p: 2,
                    minWidth: 350,
                    maxWidth: 500
                }
            }}
        >
            <DialogTitle>
                <Typography variant="h6" textAlign="center" fontWeight="bold">
                    {title}
                </Typography>
            </DialogTitle>

            <DialogContent>
                <DialogContentText sx={{ textAlign: "center", fontSize: 16 }}>
                    {text}
                </DialogContentText>
            </DialogContent>

            {!hideDefaultButtons && (
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 2,
                        mt: 2
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={fnConfirmAction}
                        sx={{ borderRadius: 2, minWidth: 100 }}
                    >
                        {labelConfirm || "Confirm"}
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={fnClose}
                        sx={{ borderRadius: 2, minWidth: 100 }}
                    >
                        {labelClose || "Cancel"}
                    </Button>
                </DialogActions>
            )}

            {customActions && (
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 2,
                        mt: 2
                    }}
                >
                    {customActions}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default HomeMadeDialog;
